import { selectToken } from '@redux/authent/authent.selectors';

import { useAppSelector } from './redux.hooks';

export const useAuth = () => {
  const token = useAppSelector(selectToken);
  return { token };
};
